<template>
    <span>
        <font-awesome-icon 
            class="bookmark-icon fa-lg mr-2" 
            :icon="['fas', 'bookmark']"
            v-if="isBookmarked"
            @click="removeBookmark"     
        />
        <font-awesome-icon
        class="bookmark-icon fa-lg mr-2"
        :icon="['far', 'bookmark']"
        @click="saveBookmark"
        v-else />
    </span>
</template>

<script>
    import api from "@/api";
    import * as CONSTANTS from "@/store/constants";
    

    export default {
    name: "AutodeskOneToggleBookmarkPage",
    data() {
            return {
                isBookmarked: true,
                bookmark: {},
            };
    },
    props: {
            bookmarkRowValue: {
                type: Object,
                required: true
            }
    },
    methods:{
        async saveBookmark() {
            api
            .saveBookmark(this.bookmarkRowValue.title, this.bookmarkRowValue.url)
            .then((response) => {
                const { data: bookmark } = response;
                this.bookmarkRowValue.id = response.data.id
                let updateBookmarkStatus = this.bookmarkRowValue.title + CONSTANTS.BOOKMARK_ADDED_SUCCESS
                this.updateMessage('Success', updateBookmarkStatus)
                this.bookmark = { ...bookmark };
                this.isBookmarked = true;
                this.trackEvent("Bookmark saved", this.bookmarkRowValue.title);
            }).catch(err => {
            this.updateMessage('Error', CONSTANTS.ERROR_MESSAGE)
        });
        },

        async removeBookmark() {
             api
             .removeBookmark(this.bookmarkRowValue.id,this.bookmarkRowValue.sourceType)
             .then(() => {
                let updateBookmarkStatus = this.bookmarkRowValue.title + CONSTANTS.BOOKMARK_REMOVED_SUCCESS
                this.updateMessage('Success', updateBookmarkStatus)
                this.isBookmarked = false;
                this.trackEvent("Bookmark removed", this.bookmarkRowValue.title);
                }).catch(err => {
                    this.updateMessage('Error', CONSTANTS.ERROR_MESSAGE)
                })
            },
        updateMessage(messageType, messageText) {
                this.$emit( 'update', { messageType: messageType,messageText: messageText })
            }
    }
    
}
</script>
<style scoped>
.bookmark-icon {
    color: #2BC275 !important;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/pages/AutodeskOneToggleBookmarkPage.vue